import { FormControl, FormErrorMessage } from "@chakra-ui/react";
import { type FieldErrors } from "react-hook-form";

import { KnownAccountsAutocomplete } from "../../../AddressAutocomplete";
import { type FormValues } from "../useSendShieldedForm";

type ToAddressFieldProps = {
  errors: FieldErrors<FormValues>;
  validateAddress: (value: string) => true | string;
  isDisabled?: boolean;
};

export const ToAddressField = ({ errors, validateAddress, isDisabled }: ToAddressFieldProps) => (
  <FormControl isInvalid={!!errors.toAddress}>
    <KnownAccountsAutocomplete
      accountsType="all"
      allowUnknown
      inputName="toAddress"
      isDisabled={isDisabled}
      label="To"
      validate={validateAddress}
    />
    {errors.toAddress && (
      <FormErrorMessage data-testid="to-address-error">{errors.toAddress.message}</FormErrorMessage>
    )}
  </FormControl>
);
